import { AuditLogRole } from "../../../../models/Entities";

export const ROLE_LABEL: Record<AuditLogRole, string> = {
  [AuditLogRole.ADMIN]: "Admin",
  [AuditLogRole.DEVELOPER]: "Developer",
  [AuditLogRole.MEMBER]: "Member",
  [AuditLogRole.SUPPORT]: "Support",
  [AuditLogRole.MERGE_TEAM]: "Merge Support",
  [AuditLogRole.SYSTEM]: "System",
  [AuditLogRole.API]: "API",
  [AuditLogRole.END_USER]: "End user",
};
